import * as React from 'react';
import useHttpClient, { getHeader } from './useHttpClient';
import { AuStateType } from '../utils/constants';
import { TrackEvent, formatError } from '../hooks/useAnalytics';
export interface AddressDataType {
  fullAddress: boolean;
  moniker: string;
  partialAddress: string;
  picklist: string;
  postcode: string;
  score: number;
  state: AuStateType;
}

interface SearchType {
  searchTerm: string;
  searchTermLimit?: number;
}

export const useSearchAddress = () => {
  const [addressList, setAddressList] = React.useState<Partial<AddressDataType>[]>([]);
  const [searchValue, setSearchValue] = React.useState('');
  const trackedError = React.useRef('');
  const [{ error, loading: searching }, getAddress, cancelSearching] = useHttpClient(
    {
      url: '/x-digital-remediation-qbe-anzo/api/v1/addresses',
    },
    { manual: true }
  );

  const searchAddress = async ({ searchTerm, searchTermLimit = 4 }: SearchType) => {
    setSearchValue(searchTerm);
    try {
      if (searchTerm.length >= searchTermLimit) {
        cancelSearching();
        const { data } = await getAddress({
          method: 'GET',
          params: { searchTerm },
          headers: getHeader(),
        });

        setAddressList(data.addressList);
        return data.addressList;
      }
    } catch (errorTc) {
      if (errorTc && errorTc instanceof Error && errorTc.message !== trackedError.current) {
        TrackEvent(formatError('technical_error', 'searchAddress try/catch error', JSON.stringify(errorTc)));
        trackedError.current = errorTc.message;
      }
      return null;
    }
  };

  if (error && error.message !== trackedError.current) {
    TrackEvent(formatError('technical_error', 'searchAddress axios error', JSON.stringify(error)));
    trackedError.current = error.message;
  }

  const clearAddressList = () => setAddressList([]);

  return { searchAddress, addressList, error, clearAddressList, searchValue, searching, cancelSearching };
};
